import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoadState } from "../../constants/enums";
import {
  initialMirtapbxCallContextState,
  IPendingCallScope,
} from "./mirtapbxCallContext.types";
import { createCallContextAsync, pollCallContextAsync } from "./mirtapbxCallContextThunk";

const mirtapbxCallContextSlice = createSlice({
  name: "mirtapbxCallContext",
  initialState: initialMirtapbxCallContextState,
  reducers: {
    clearCallContext: (state) => {
      state.current = null;
      state.createLoading = LoadState.NotLoaded;
      state.pollStatus = "IDLE";
      state.error = null;
    },
    // <CallButton> on CRM screens stamps the scope here before firing
    // sipClient.call(). The widget's placeWebrtcCall helper consumes it.
    setPendingCallScope: (
      state,
      action: PayloadAction<Omit<IPendingCallScope, "set_at">>,
    ) => {
      state.pendingScope = { ...action.payload, set_at: Date.now() };
    },
    clearPendingCallScope: (state) => {
      state.pendingScope = null;
    },
  },
  extraReducers: (builder) => {
    // Create Call Context
    builder.addCase(createCallContextAsync.pending, (state) => {
      state.createLoading = LoadState.InProgress;
      state.error = null;
    });
    builder.addCase(createCallContextAsync.fulfilled, (state) => {
      state.createLoading = LoadState.Loaded;
      state.error = null;
    });
    builder.addCase(createCallContextAsync.rejected, (state, action) => {
      state.createLoading = LoadState.Failed;
      state.error = action.payload?.message || "Failed to create call context";
    });

    // Poll Call Context
    builder.addCase(pollCallContextAsync.pending, (state) => {
      state.error = null;
    });
    builder.addCase(pollCallContextAsync.fulfilled, (state, action) => {
      state.current = action.payload;
      state.pollStatus = action.payload.link_status;
      state.error = null;
    });
    builder.addCase(pollCallContextAsync.rejected, (state, action) => {
      state.error = action.payload?.message || "Failed to poll call context";
    });
  },
});

export const {
  clearCallContext,
  setPendingCallScope,
  clearPendingCallScope,
} = mirtapbxCallContextSlice.actions;
export const mirtapbxCallContextReducer = mirtapbxCallContextSlice.reducer;
